module.exports = __webpack_public_path__ + "static/media/payments.27d95e8c.svg";